import { useLanguage } from './useLanguages'

export default function useLanguagesV2() {
  const state = useLanguage()
  return state
}
